export default __webpack_public_path__ + "static/media/Group9182.4ec2ab32.svg";